/**
 * 播放顺序
 */
export const PLAY_ORDER = {
  FORWARD: 1, // 向前
  BACKWARDS: -1 // 向后
};

/**
 * 播放状态
 */
export const PLAY_STATUS = {
  PLAYING: 1, //正在播放
  PAUSE: -1 //暂停
};

export const FORMAT_TIMER_SHAFT = 'YYYY-MM-DD HH:mm:ss';

export const FORMAT_TIMER_SHAFT_ZERO = 'YYYY-MM-DD [00:00:00]';

export const FORMAT_TIMESTAMP = 'YYYYMMDDHH[00]';

export const FORMAT_TIME = 'HH:mm:ss';

export const FORMAT_DATE = 'YYYY-MM-DD';

export const FLOW_COLORS = [
  '#DA0055',
  '#DA0055',
  '#DA0055',
  '#DA0055',
  '#E00545',
  '#E00545',
  '#F31323',
  '#FC1A11',
  '#FF2511',
  '#FF3115',
  '#FF3E19',
  '#FF4A1C',
  '#FF4F1D',
  '#FF531D',
  '#FF561D',
  '#FF5B1D',
  '#FF611D',
  '#FF651D',
  '#FF6A1D',
  '#FF701C',
  '#FF771C',
  '#FF7E1B',
  '#FF861B',
  '#FF8E1B',
  '#FF961B',
  '#FF9F1C',
  '#FFA71C',
  '#FFB21E',
  '#FFBC1F',
  '#FFC621',
  '#FFD023',
  '#FAD825',
  '#F4DE27',
  '#EDE52A',
  '#E8EA2B',
  '#D3E52C',
  '#BCDF2E',
  '#AADB2F',
  '#94D530',
  '#7DCF31',
  '#68C933',
  '#53C334',
  '#3FBA43',
  '#2AA87F',
  '#1897B3',
  '#0888E5',
  '#007AFF',
  '#0072FF',
  '#0069FF',
  '#0060FF'
].reverse();
